/**
 * templateRender.ts — LINE ページのテンプレート（line_message_templates）の差し込み（純関数）
 *
 * LineChatPanel にあった処理を切り出したもの（2026-10-26）。自社チャット（予約チャット・匿名チャット）の
 * 入力欄でも同じテンプレートを使う（booking-platform/md/customer-chat.md §13）。
 * 書式: `{変数}` の置換と `{% if 変数 == 値 %}…{% elseif 変数 != 値 %}…{% else %}…{% endif %}`。
 */
export function renderTemplate(content: string, vars: Record<string, unknown>): string {
  let result = content;

  // 1. Handle IF logic with ELSIF and ELSE
  const ifRegex = /\{%\s*if\s+([a-zA-Z0-9_]+)\s*(==|!=)\s*([^\s%\}]+)\s*%\}([\s\S]*?)\{%\s*endif\s*%\}/gi;

  result = result.replace(ifRegex, (match, varName, op, val, fullInner) => {
    const currentVal = String(vars[varName.toLowerCase()] || '');
    const compareVal = val.trim().replace(/['"]/g, '');

    // 区切りは非キャプチャにする（キャプチャすると split の結果に 'elseif' / 'else' が混ざり、分岐の本文の代わりに
    // その文字が入っていた。LineChatPanel 時代からの不具合・2026-10-26 修正＝templateRender.test.ts）
    const parts = fullInner.split(/\{%\s*(?:elseif|else).*?%\}/i);
    const matches = fullInner.match(/\{%\s*(elseif|else)\s*([a-zA-Z0-9_]*)\s*(==|!=)?\s*([^\s%\}]*)?\s*%\}/gi) || [];

    const condition = (op === '==') ? (currentVal === compareVal) : (currentVal !== compareVal);
    if (condition) return parts[0];

    for (let i = 0; i < matches.length; i++) {
      const tag = matches[i];
      const inner = parts[i + 1];

      if (tag.toLowerCase().includes('elseif')) {
        const m = tag.match(/elseif\s+([a-zA-Z0-9_]+)\s*(==|!=)\s*([^\s%\}]+)/i);
        if (m) {
          const eVar = m[1].toLowerCase();
          const eOp = m[2];
          const eVal = m[3].trim().replace(/['"]/g, '');
          const ecVal = String(vars[eVar] || '');
          if ((eOp === '==') ? (ecVal === eVal) : (ecVal !== eVal)) {
            return inner;
          }
        }
      } else if (tag.toLowerCase().includes('else')) {
        return inner;
      }
    }
    return '';
  });

  Object.keys(vars).forEach(key => {
    const regex = new RegExp(`{${key}}`, 'g');
    result = result.replace(regex, String(vars[key] ?? ''));
  });

  return result;
}

/** 予約日時の表示（テンプレートの start_date など）。`MM/DD HH:MM`。読めなければそのまま */
export const templateDateTime = (v: unknown): string => {
  if (typeof v !== 'string' || !v) return '';
  const d = new Date(v.includes('T') ? v : v.replace(/-/g, '/'));
  if (Number.isNaN(d.getTime())) return v;
  const p = (n: number) => String(n).padStart(2, '0');
  return `${p(d.getMonth() + 1)}/${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`;
};
export const templateTime = (v: unknown): string => {
  if (typeof v !== 'string' || !v) return '';
  const d = new Date(v.includes('T') ? v : v.replace(/-/g, '/'));
  if (Number.isNaN(d.getTime())) return v;
  const p = (n: number) => String(n).padStart(2, '0');
  return `${p(d.getHours())}:${p(d.getMinutes())}`;
};
